export default __webpack_public_path__ + "static/media/avi-werde-hHz4yrvxwlA-unsplash.32879e06.jpg";